import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.02 2q-.664 0-1.344.086c-4.572.588-8.222 4.401-8.633 8.992-.58 6.487 5.038 11.836 11.602 10.791 4.13-.658 7.478-3.962 8.199-8.082a10.04 10.04 0 0 0-.39-5.05c-.24-.693-1.11-.91-1.628-.393l-.053.052a.96.96 0 0 0-.21.999 8.07 8.07 0 0 1 .236 4.416c-.678 3.053-3.187 5.474-6.262 6.046a8.014 8.014 0 0 1-9.385-9.445c.597-3.107 3.085-5.619 6.186-6.244 2.483-.5 4.806.16 6.557 1.523l-1.43 1.43a5.96 5.96 0 0 0-4.293-1.064c-2.607.35-4.74 2.46-5.11 5.064a6.006 6.006 0 0 0 6.862 6.81c2.12-.316 3.914-1.833 4.68-3.835.174-.454.284-.9.343-1.334.128-.943-1.042-1.497-1.715-.825a1.06 1.06 0 0 0-.285.61 3.993 3.993 0 0 1-4.916 3.34 3.97 3.97 0 0 1-2.92-2.926A4.008 4.008 0 0 1 12 8c.742 0 1.433.207 2.025.56l-1.51 1.51A2 2 0 0 0 12 10a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-.068-.518l7.361-7.36a.999.999 0 1 0-1.414-1.415L18.316 4.27A9.94 9.94 0 0 0 12.02 2" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }